import { render, staticRenderFns } from "./My.vue?vue&type=template&id=24c2f0da&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"
import style0 from "./My.vue?vue&type=style&index=0&id=24c2f0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2f0da",
  null
  
)

export default component.exports